function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable */

/* tslint:disable */
import React from 'react';

var x = function x(_ref) {
  var size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, ["size"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "currentColor",
    width: size || "15",
    height: size || "15"
  }, props), React.createElement("path", {
    d: "M15 0.6L14.4 0 7.5 6.9 0.6 0 0 0.6 6.9 7.5 0 14.4 0.6 15 7.5 8.1 14.4 15 15 14.4 8.1 7.5z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
};

x.displayName = 'x';
export default x;
/* tslint:enable */

/* eslint-enable */